import React from 'react';
import styled from 'styled-components';
import { BlockSpan, Icon, IconAsc, IconDesc } from './styles';
import { ColumnValues, OrderValues, TableColumn } from './types';

interface Props {
  columns: TableColumn[];
  className?: string;
  state: {
    column: ColumnValues;
    order: OrderValues;
  };
  onClickColumn: (sortKey: string) => void;
}

type ThProps = {
  widthOverride?: string;
  sort?: boolean | string;
};

const Th = styled.th`
  width: ${(props: ThProps) =>
    props.widthOverride ? props.widthOverride : 'auto'};
  cursor: ${(props) => (props.sort ? 'pointer' : 'initial')};
`;

const THead: React.FC<Props> = ({
  columns = [],
  onClickColumn,
  className = '',
  state,
  ...restProps
}: Props) => {
  const ascendingIcon = <IconAsc>&#8964;</IconAsc>;
  const descendingIcon = <IconDesc>&#8964;</IconDesc>;
  const icon = <Icon>&#8964;</Icon>;

  return (
    <thead {...restProps}>
      <tr>
        {columns.map(
          ({
            key = '',
            title = '',
            sort = false,
            sortKey = false,
            ...rest
          }: TableColumn) => (
            <Th
              key={key}
              data-testid={`employee-table-thead-${title}`}
              className={className}
              sort={sort as boolean}
              onClick={() => sort && onClickColumn((sortKey as string) || key)}
              {...rest}
            >
              <BlockSpan>
                <span>{title}</span>
                {sort && (
                  <BlockSpan className="sort-icons">
                    {state.column === key || state.column === sortKey
                      ? state.order === 'asc'
                        ? ascendingIcon
                        : descendingIcon
                      : icon}
                  </BlockSpan>
                )}
              </BlockSpan>
            </Th>
          )
        )}
      </tr>
    </thead>
  );
};

export default THead;
